export default __webpack_public_path__ + "static/media/autoportrait3.7dd179fa.jpg";